import React from 'react'
import { useSelector } from "react-redux"


export default function TradeInLoader(){
    const isFetching = useSelector(state => state.tradeInReducer.show_trade_in_spinner)
    return (
        <div className={isFetching ? 'loading loading-text' : 'clear'}>
            <div className="loading-trade-in">
                <div className="loading-trade-in__top-msg">…adding item(s) to cart</div>
                <div className="loading-trade-in__bottom-msg">Sending you to the Trade screen</div>
            </div>
        </div>
    )
}
